module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audience-hub-table"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "start",
      "dense": "",
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.targetFilterOptions,
      "item-text": "name",
      "item-value": "value",
      "label": "Targets",
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "input": _vm.onTargetFilterChange
    },
    model: {
      value: (_vm.queryOption),
      callback: function($$v) {
        _vm.queryOption = $$v
      },
      expression: "queryOption"
    }
  })], 1), _vm._v(" "), _c('v-col', _vm._l((_vm.appliedFilters), function(filter) {
    return _c('v-chip', {
      key: filter.name,
      staticClass: "ma-1",
      attrs: {
        "color": "teal",
        "text-color": "white",
        "close": ""
      },
      on: {
        "click:close": function($event) {
          return _vm.clearFilter(filter)
        }
      }
    }, [_vm._v("\n          " + _vm._s(filter.name) + " " + _vm._s(filter.value) + "\n        ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-theme-material",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "defaultColDef": _vm.defaultColDef,
      "frameworkComponents": _vm.frameworkComponents,
      "columnDefs": _vm.columnDefs,
      "getRowNodeId": _vm.getRowNodeId,
      "masterDetail": true,
      "detailCellRenderer": _vm.audienceDetailRenderer,
      "getRowHeight": _vm.detailRowHeight,
      "isExternalFilterPresent": _vm.isExternalFilterPresent,
      "doesExternalFilterPass": _vm.doesExternalFilterPass,
      "tooltipShowDelay": 0,
      "rowModelType": "serverSide",
      "blockLoadDebounceMillis": 500,
      "enableRangeSelection": true,
      "allowContextMenuWithControlKey": true,
      "getContextMenuItems": _vm.getContextMenuItems,
      "overlayLoadingTemplate": "<span class='ag-overlay-loading-center'>Audiences Loading...</span>",
      "overlayNoRowsTemplate": "<div class='ag-overlay-loading-center' style='background-color: white;'><i class='far fa-frown'>0 Records Returned</i></div>",
      "rowHeight": "45"
    },
    on: {
      "gridReady": _vm.onGridReady,
      "filterChanged": _vm.onFilterChanged,
      "columnEverythingChanged": _vm.onColumnEverythingChanged
    }
  }), _vm._v(" "), _c('re-posting-modal'), _vm._v(" "), _c('delete-target-modal'), _vm._v(" "), _c('append-target-modal'), _vm._v(" "), _c('download-pid-list-modal', {
    attrs: {
      "title": "Download PID Lists"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c08dd8e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/audienceHubDashboard/AudienceHubTable.vue
// module id = 2140
// module chunks = 0